/**
 * RuleFormSection - a titled group of fields inside the rule side panels.
 *
 * `FormSection` draws a glass card per group, which is right on a page and
 * wrong inside a side panel: the panel IS the glass, so each group became a
 * white box on it and the fields inside lost their grey `bg-field` well.
 * Here a group is only a quiet label and a gap - the fields carry the shape.
 *
 * Shared by the clause-rule and global-rule panels so the two read alike.
 */

import React from 'react';

interface Props {
  /** Already-translated. */
  title: string;
  children: React.ReactNode;
}

const RuleFormSection: React.FC<Props> = ({ title, children }) => (
  <section className="space-y-4">
    <h3 className="text-xs font-medium text-fg-muted">{title}</h3>
    {children}
  </section>
);

export default RuleFormSection;
